import { AppModule } from "./app/app.module";
import { platformBrowser } from "@angular/platform-browser";
import { provideZoneChangeDetection } from "@angular/core";
import { AllCommunityModule, ModuleRegistry } from "ag-charts-community";

// AG Charts v13+ uses a modular architecture and no longer auto-registers modules.
// Register all community modules once before any chart renders.
ModuleRegistry.registerModules(AllCommunityModule);

// Angular 21+ enables zoneless change detection by default. This app relies on
// zone.js to trigger change detection after async work (HTTP, timers), so we
// opt back into zone-based change detection at the application provider level.
platformBrowser()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
